// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GalleryPage_wrapper__xepNp","debug":"GalleryPage_debug__pSdCK","searchWrapper":"GalleryPage_searchWrapper__eHMZu","searchInput":"GalleryPage_searchInput__HE6Jq"};